import React, { useState } from "react";
import {
  Box,
  Container,
  AppBar as MuiAppBar,
  Toolbar,
  IconButton,
  TextField,
  Button
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import TemporaryDrawer from "./components/temporaryDrawer";
import Content from "./components/content";
import SunnuntaiU8 from "./components/sunnuntaiU8";
import SunnuntaiU9 from "./components/sunnuntaiU9";
import LauantaiU7 from "./components/lauantaiU7";
import LauantaiU8 from "./components/lauantaiU8";
import Lamaritutka from "./components/lamaritutka";
import GameChanger from "./components/gameChangerResult";
import LamaritutkaSun from "./components/lamaritutkaSun";
import GameChangerSun from "./components/gameChangerResultSun";
import PukukoppiLa from "./components/pukukoppiLa";
import PukukoppiSun from "./components/pukukoppiSun"

import "./App.css";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#fff"
}));

function App() {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "turnausInfo");
  const [isAdmin, setIsAdmin] = useState(() => {
    const storedAdmin = localStorage.getItem("isAdmin");
    return storedAdmin === "true";
  });
  const [adminCode, setAdminCode] = useState("");
  const [subTab, setSubTab] = useState(localStorage.getItem("subTab") || "null");

  const toggleDrawer = () => setOpen((prevOpen) => !prevOpen);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem("activeTab", tab);
    if (tab === "lauantai") {
      setSubTab("u7");
      localStorage.setItem("subTab", "u7");
    } else if (tab === "sunnuntai") {
      setSubTab("u8");
      localStorage.setItem("subTab", "u8");
    } else if (tab === "pukukopit") {
      setSubTab("pukukoppiLa");
      localStorage.setItem("subTab", "pukukoppiLa");
    }
  };

  const handleSubTabChange = (tab) => {
    setSubTab(tab);
    localStorage.setItem("subTab", tab); 
  };

  const handleLogin = () => {
    if (adminCode === "2025") {
      setIsAdmin(true);
      localStorage.setItem("isAdmin", "true");
    } else {
      alert("Incorrect code!");
    }
  };

  const handleLogout = () => {
    setIsAdmin(false);
    setAdminCode("");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("subTab");
  };

  const renderContent = () => {
    if (activeTab === "sunnuntai") {
      if (subTab === "u9") return <SunnuntaiU9 isAdmin={isAdmin} />;
      if (subTab === "u8") return <SunnuntaiU8 isAdmin={isAdmin} />;
      if (subTab === "lamaritutkaSun") return <LamaritutkaSun isAdmin={isAdmin} />;
      if (subTab === "gameChangerResultSun") return <GameChangerSun isAdmin={isAdmin} />;
    } else if (activeTab === "lauantai") {
      if (subTab === "u7") return <LauantaiU7 isAdmin={isAdmin} />;
      if (subTab === "u8") return <LauantaiU8 isAdmin={isAdmin} />;
      if (subTab === "lamaritutka") return <Lamaritutka isAdmin={isAdmin} />;
      if (subTab === "gameChangerResult") return <GameChanger isAdmin={isAdmin} />;
    } else if (activeTab === "pukukopit") {
      if (subTab === "pukukoppiLa") return <PukukoppiLa isAdmin={isAdmin}/>;
      if (subTab === "pukukoppiSun") return <PukukoppiSun isAdmin={isAdmin}/>;
    }else {
      return <Content isAdmin={isAdmin} activeTab={activeTab} subTab={subTab} />;
    }
  };

  const showAdminFooter = (
    (activeTab === "lauantai" || activeTab === "sunnuntai")
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* AppBar */}
      <AppBar position="fixed" className="customed-header">
        <Toolbar>
          <Container
            maxWidth="lg"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: 2,
              paddingBottom: 2
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", marginRight: "5vw" }}>
            <IconButton
              color="inherit"
              onClick={toggleDrawer}
              edge="start"
              sx={{ display: "flex" }}
            >
              {open ? (
                <CloseIcon sx={{ color: "black", fontSize: "35px" }} />
              ) : (
                <MenuIcon sx={{ color: "black", fontSize: "35px" }} />
              )}
            </IconButton>

            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              <img
                src="https://files.eliteprospects.com/layout/logos/f667f640-87d9-4879-b248-dde1387fac00_large.png"
                alt="Logo"
                style={{ height: 50 }}
              />
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3mBIxJxoOPvfE97RGBiC6nmlmFxHAWQKMbQ&s"
                alt="autosalpa"
                style={{ height: 40 }}
              />
            </Box>
          </Container>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <TemporaryDrawer
        open={open}
        onClose={toggleDrawer}
        onTabChange={handleTabChange}
        activeTab={activeTab}
        onSubTabChange={handleSubTabChange}
        subTab={subTab}
       
      />

      {/* Content */}
      <Box sx={{ flexGrow: 1, mt: 9 }}>
        <Container maxWidth="lg">{renderContent()}</Container>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          backgroundColor: "#fff",
          padding: "10px",
          textAlign: "center",
          borderTop: "1px solid #ccc"
        }}
      >
        {showAdminFooter ? (
          <Box sx={{ display: "flex", justifyContent: "left", alignItems: "left", gap: 2 }}>
            {!isAdmin ? (
              <>
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Koodi"
                  value={adminCode}
                  onChange={(e) => setAdminCode(e.target.value)}
                  sx={{
                    width: "80px",
                    backgroundColor: "white",
                    "& .MuiInputBase-input": { fontSize: "0.7rem", padding: "6px" },
                    "& .MuiOutlinedInput-root": { borderRadius: "0px" }
                  }}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleLogin}
                  sx={{ width: "80px", height: "30px", fontSize: "0.7rem" }}
                >
                  Log In
                </Button>
              </>
            ) : (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={handleLogout}
                sx={{ width: "90px", backgroundColor: "white" }}
              >
                Logout
              </Button>
            )}
          </Box>
        ) : (
          <Box sx={{ paddingTop: "14px", paddingBottom:"14px", fontSize: "0.9rem", color: "black" }}>
            © 2025 SIPOON WOLF U8/U9
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default App;
